import React from 'react';
import {
  List,
  Datagrid,
  SelectField,
  TextField,
  EditButton,
} from 'react-admin';
import { adminRoleType } from 'utils/choices';

// Remove manual pagination when Material-UI bug has been fixed
// See Components/Pagination for github link to issue
import { Pagination } from 'Components';

const AdminList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    exporter={false}
    pagination={<Pagination />}
    perPage={50}
  >
    <Datagrid>
      <TextField source="firstName" sortable={false} />
      <TextField source="lastName" sortable={false} />
      <TextField source="email" sortable={false} />
      <SelectField source="role" choices={adminRoleType} sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export default AdminList;
